/* eslint-disable sort-keys,sort-keys-fix/sort-keys-fix */
const envLists = import.meta.env
export const isProduction = import.meta.env.VITE_APP_ENV === "production"
// 判断是否为shopify嵌入式环境
export const isShopifyEnv = !!window.shopify
console.log(
  `%c当前环境: %c${envLists.VITE_APP_ENV}`,
  "color: #888; font-weight: bold;",
  "color: red; font-weight: bold;",
)

const apiMap = {
  production: {
    api: "https://return-api.parcelwill.com",
    goApi: "https://return-go-api.parcelwill.com",
  },
  test: {
    api: "https://api-return-test.parcelpanel.com",
    goApi: "https://api-return-test-go.parcelpanel.com",
  },
  local: {
    api: "https://api-return-test.parcelpanel.com",
    goApi: "https://api-return-test-go.parcelpanel.com",
  },
} as const
const apiInfo = apiMap[envLists.VITE_APP_ENV] || apiMap.production

interface IEnvHelper {
  /**
   * 自己定义的环境变量
   */
  env: string

  /**
   * vite 运行模式
   */
  mode: string

  /**
   * 是否为开发环境
   */
  isDev: boolean

  /**
   * 是否为生产环境
   */
  isProd: boolean

  /**
   * 仅在 VITE_APP_ENV=local 时此设置才有效，模拟登陆哪个用户
   */
  mockLoginUid: number

  /**
   * 后端 API 地址
   */
  apiURL: string

  /**
   * 后端 Go API 地址
   */
  goApiURL: string

  /**
   * 应用凭据 >>> API 密钥
   */
  shopifyApiKey: string

  /**
   * 是否启用将 URL 中 http 替换为 https 链接
   */
  enableHttpReplaceHttps: boolean

  /**
   * 主题扩展-应用程序块 UUID
   */
  // extensionUUID: string

  /**
   * i18n 调试模式
   */
  i18nDebug: boolean

  /**
   * 默认显示语言
   */
  defaultLang: string

  /**
   * Cookie 名前缀
   */
  cookieNamePrefix: string

  /**
   * 是否令插件为预览模式
   */
  pluginIsPreview: boolean

  /**
   * 插件构建时间
   */
  pluginBuildTime: string
}

const EnvHelper: IEnvHelper = {
  // 自己定义的
  get env() {
    return envLists.VITE_APP_ENV
  },

  // vite 自带的判断条件
  get mode() {
    return envLists.MODE
  },

  get isDev() {
    return envLists.DEV
  },

  get isProd() {
    return envLists.PROD
  },

  // /////////
  // 自定义
  get mockLoginUid() {
    return Number(envLists.VITE_MOCK_LOGIN_UID)
  },

  get apiURL() {
    return apiInfo.api
  },

  get goApiURL() {
    return apiInfo.goApi
  },

  get shopifyApiKey() {
    return envLists.VITE_SHOPIFY_API_KEY
  },

  get defaultLang() {
    return envLists.VITE_DEFAULT_LANG ?? "en"
  },

  get enableHttpReplaceHttps() {
    return !isProduction
  },

  // get extensionUUID() {
  //   return envLists.VITE_EXTENSION_UUID
  // },

  get i18nDebug() {
    return "true" === envLists.VITE_I18N_DEBUG
  },

  get cookieNamePrefix() {
    return envLists.VITE_COOKIE_NAME_PREFIX
  },

  get pluginIsPreview() {
    return "true" === envLists.VITE_PLUGIN_IS_PREVIEW
  },

  get pluginBuildTime() {
    return envLists.VITE_PLUGIN_BUILD_TIME
  },
}

export default EnvHelper as IEnvHelper
